import React, { useState } from 'react';
import { Container, Typography, FormControl, InputLabel, Select, MenuItem, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { addLicense } from '../../redux/actions/managementActions';
import { useSelector, useDispatch } from 'react-redux';
import { buildLicenseDescription } from '../../util/helpers/other';
import LoadingButton from '../widgets/LoadingButton';
import { Skeleton } from '@material-ui/lab';
import { pickBy, isEmpty } from 'lodash';
import { useIntl } from 'react-intl';
import { getAllFromDividedQuery } from '../../util/helpers/redux';

const useStyles = makeStyles((theme) => ({
  container: {
    ...theme.container(2),
    marginLeft: 0,
    maxWidth: '800px',
  },
  title: {
    color: theme.palette.other.grey.dark,
    marginBottom: theme.spacing(2),
  },
  formControl: {
    width: '100%',
  },
  input: {
    marginBottom: theme.spacing(2),
  },
}));

export default function AddLicense(props) {
  const { match } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [licenseKey, setLicenseKey] = useState('');
  const { licensesData, ui } = useSelector(({ firestore, ui }) => ({
    licensesData: getAllFromDividedQuery(firestore, 'licenses'),
    ui,
  }));

  const { isLoaded: licensesIsLoaded, data: licenses } = licensesData;

  let unusedLicenses = licensesIsLoaded
    ? pickBy(licenses, (license, key) => !license.authDomains.includes(match.params.domain))
    : {};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(licenseKey)) {
      return;
    }

    dispatch(
      addLicense({
        domain: match.params.domain,
        licenseKey,
      })
    );
  };

  return (
    <Container className={classes.container}>
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" className={clsx(classes.title)}>
          {intl.formatMessage({ id: 'addLic.title' }, { domain: match.params.domain })}
        </Typography>

        {licensesIsLoaded ? (
          !isEmpty(unusedLicenses) ? (
            <>
              <FormControl className={classes.formControl}>
                <InputLabel id="license-select-label">{intl.formatMessage({ id: 'addLic.license' })}</InputLabel>
                <Select
                  labelId="license-select-label"
                  id="license-select"
                  value={licenseKey}
                  onChange={(e) => setLicenseKey(e.target.value)}
                  className={classes.input}
                >
                  {Object.entries(unusedLicenses).map(([key, lic]) => (
                    <MenuItem key={key} value={key} disabled={lic?.isActive === false}>
                      {buildLicenseDescription(unusedLicenses[key], key, intl)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LoadingButton
                isLoading={ui.loadingButton.isAddLicenseLoading}
                content={intl.formatMessage({ id: 'addLic.addBtn' })}
                type="submit"
              />
            </>
          ) : (
            <Typography>{intl.formatMessage({ id: 'addLic.noUnused' })}</Typography>
          )
        ) : (
          <Skeleton variant="rect" animation="wave" height={30} />
        )}
      </form>
    </Container>
  );
}
